import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      backgroundColor: '#EFF5EC',
      color: '#1C4827',
      textTransform: 'none',
      padding: '10px 16px',
      borderRadius: '8px',
      boxShadow:
        '0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.30)',
      '&:hover': {
        backgroundColor: '#D6E8DA',
      },
    },
    hover: {
      backgroundColor: '#D6E8DA',
      boxShadow: 'none',
    },
    span: {
      fontSize: '14px',
      fontFamily: theme.typography.body2.fontFamily,
      fontWeight: 600,
      color: '#001D29',
    },
    icon: {
      color: '#001D29',
    },
    menu: {
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)',
      '& .MuiList-padding': {
        padding: 0,
      },
      '& .MuiMenu-paper': {
        borderRadius: '8px',
      },
    },
    menuItem: {
      backgroundColor: '#DEE5DA',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      color: '#001D29',
      fontSize: '14px',
      padding: theme.spacing(2, 2.5),
      fontFamily: theme.typography.body2.fontFamily,
      fontWeight: 600,
      '&:hover': {
        backgroundColor: '#006E2C',
        color: '#fff',
        '& .MuiSvgIcon-root': {
          color: '#fff',
        },
      },
    },
    menuIcon: {
      fontSize: 26,
      color: '#006E2C',
    },
  }),
)
